/**
 * renders activities for
 */

angular.module('cfn').factory('journalRenderService', [
  'i18nFilter',
  function(i18nFilter) {
    return {
      journalRenderer: function(rowIndex, column, value, rowValue) {
        if (!rowValue) return undefined;
        var result;
        var templateName = rowValue.templateName;

        return templateName
          ? templateName
          : i18nFilter('enums.BookingActivitiesEnum.' + rowValue.activityName);
      }
    };
  }
]);
